import { overlay } from 'overlay-kit';

import { useScrapingJobs } from '../hooks/use-scraping-jobs';
import { DirectUrlScrapingDialog } from './DirectUrlScrapingDialog/DirectUrlScrapingDialog';
import { DirectUrlScrapingTable } from './DirectUrlScrapingTable/DirectUrlScrapingTable';

import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { PageNavigationView } from '@/shared/components/page-navigation';
import { Spacer } from '@/shared/components/spacer';
import { useState } from 'react';

const ITEM_PER_PAGE = 10;

export function DirectUrlScrapingList() {
  // Url scraping is only supported for TikTok platform for now
  const [platform] = useState<SOURCE_PLATFORM_TYPE>(SOURCE_PLATFORM_TYPE.TIKTOK);
  const {
    jobs,
    totalCount,
    canGoPrevious,
    canGoNext,
    goToPrevious,
    goToNext,
    currentPage,
    isLoading,
    isFetching,
  } = useScrapingJobs({ type: 'DIRECT_URL', limit: ITEM_PER_PAGE, platform });

  const startIndex = totalCount > 0 ? (currentPage - 1) * ITEM_PER_PAGE + 1 : 0;
  const endIndex = Math.min(startIndex + ITEM_PER_PAGE - 1, totalCount);

  const handleCreateNew = () => {
    overlay.open(({ isOpen, close, unmount }) => {
      return (
        <DirectUrlScrapingDialog
          isOpen={isOpen}
          onClose={close}
          onConfirm={() => {}}
          onExit={unmount}
        />
      );
    });
  };

  // Show initial loading state only on first load
  if (isLoading) {
    return (
      <div>
        <DirectUrlScrapingTable
          urlScrapingJobs={[]}
          total={0}
          isFetching={true}
          onCreateNew={handleCreateNew}
        />
      </div>
    );
  }

  return (
    <div>
      <DirectUrlScrapingTable
        urlScrapingJobs={jobs}
        total={totalCount}
        isFetching={isFetching}
        onCreateNew={handleCreateNew}
      />
      <hr />
      <PageNavigationView
        startIndex={startIndex}
        endIndex={endIndex}
        totalCount={totalCount}
        onPrevious={goToPrevious}
        onNext={goToNext}
        canGoPrevious={canGoPrevious}
        canGoNext={canGoNext}
      />
      <Spacer size={36} />
    </div>
  );
}
